import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import type { InterventionCenterGovStatistics } from '../../../common/types/statistics/fhbfStatistics';
import formatter from '../../../common/helpers/formatter';
import anamnesisForm from '../../../clients/detail/fhbfForm/interventionCenter/anamnesisForm';
import OptionField from './components/OptionField';

type Props = {
  statistics: InterventionCenterGovStatistics;
};

function RelationshipToThePerpetrator({ statistics }: Props) {
  const personExercisingViolenceOptions = formatter
    .getFieldSelectOptions('personExercisingViolence', anamnesisForm.fields)
    .filter((option) => option.value !== 'other');
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'block',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container rowSpacing={2}>
        <Grid item xs={12}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            5 Beziehung der beratenen Frau zum Täter
          </Typography>
        </Grid>
      </Grid>
      <Grid container pt={1} className='fhbf-print-text-value-border'>
        {personExercisingViolenceOptions
          .filter((option) => option.value !== 'unknown')
          .map((option) => (
            <OptionField
              key={`personExercisingViolence_${option.value}`}
              label={option.label}
              value={statistics.personExercisingViolence[option.value]}
            />
          ))}
        {personExercisingViolenceOptions
          .filter((option) => option.value === 'unknown')
          .map((option) => {
            const value =
              statistics.personExercisingViolence[option.value] +
              (statistics.personExercisingViolence['notSpecified'] || 0);
            return <OptionField key={`personExercisingViolence_${option.value}`} label={option.label} value={value} />;
          })}
      </Grid>
    </Paper>
  );
}

export default RelationshipToThePerpetrator;
